/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateV2Base {
    getFixupPrototypeFunction() { return TemplateV2Base.fixupPrototype; }

    static newInstance(model: Partial<TemplateV2Base>): TemplateV2Base {
        let obj = Object.assign(new TemplateV2Base(), model);
        TemplateV2Base.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateV2Base>): TemplateV2Base {
        if (!model) return null;
        return TemplateV2Base.newInstance(<TemplateV2Base> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateV2Base) {
        if (!obj) return;

        models.TemplateV2Base.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateV2Base): boolean {
        Object.setPrototypeOf(obj, TemplateV2Base.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.sub_classifications) {
            models.TemplateClassificationWithSubClassifications.fixupPrototype(this.sub_classifications);
        }
        if (this.template_type) {
            models.TemplateTypesByEngineType.fixupPrototype(this.template_type);
        }
        if (this.content_files) {
            models.TemplateContentFiles.fixupPrototype(this.content_files);
        }
        if (this.git_content) {
            models.TemplateGitContent.fixupPrototype(this.git_content);
        }
        if (this.metadata) {
            models.TemplateMetadata.fixupPrototype(this.metadata);
        }
        if (this.resource_types) {
            for (let val of this.resource_types) {
                models.TemplateResourceType.fixupPrototype(val);
            }
        }
        if (this.dependencies) {
            for (let val of this.dependencies) {
                models.TemplateDependency.fixupPrototype(val);
            }
        }
    }

    /**
     * Template name, unique, no special characters or spaces
     */
    name: string;

    /**
     * Usage of the template
     */
    description: string;

    /**
     * Terraform, CFN, ARM, Heat, Mistral, Oracle, or GCP DM
     */
    engine_type: models.TemplateEngineType;

    /**
     * The scope of the template: Global Scope - All users will have access to view and execute CoreStack Marketplace templates; will not have access to update/delete them, Account scope - All users under that account will have access to view and execute Only Account admins can update/delete the templates, Tenant Scope - Users with access to the specific tenant will have access to templates who can describe or execute templates. Tenant admins can only update/delete. Private Scope - User who created will only have access
     */
    scope: models.AccountScope;

    /**
     * Template classification(s), e.g. Deployment, Provisioning
     */
    classification: Array<models.TemplateClassification>;

    /**
     * Sub-classifications keyed by classification; each classification only permits its own sub-classifications
     */
    sub_classifications: models.TemplateClassificationWithSubClassifications;

    /**
     * Type of the template, keyed by engine - populate only the field matching 'engine_type', e.g. {\"terraform\": [\"Cloud\"]}
     */
    template_type: models.TemplateTypesByEngineType;

    /**
     * Cloud service(s) or integrated tool(s) this template targets, e.g. AWS, AzureRM, ServiceNow
     */
    provider: Array<models.ProviderName>;

    /**
     * Resource types this template operates on, grouped by cloud service
     */
    resource_types: Array<models.TemplateResourceType>;

    /**
     * Content source: file, url, or git. 'git' is only valid when engine_type='terraform'
     */
    content_type: models.TemplateContentType;

    /**
     * Content files. Required when content_type='file'
     */
    content_files: models.TemplateContentFiles;

    /**
     * Source details for content_type='url' or 'git'
     */
    git_content: models.TemplateGitContent;

    /**
     * Referenced Terraform sub-modules, each with its own content files
     */
    dependencies: Array<models.TemplateDependency>;

    /**
     * Make this template usable inside blueprints. Cannot be combined with content_type='git'
     */
    blueprint_support: boolean;

    /**
     * tags, operation_level, and operation_time stored together
     */
    metadata: models.TemplateMetadata;

}
